// Semi Truck with Trailer Icon
export const SemiTrailer = ({ className = "w-6 h-6", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Cab - Long nose style */}
    <path d="M1 12V9L3 7H8L9 9V12H1Z" strokeWidth="1.3" />
    
    {/* Cab window */}
    <rect x="4" y="7.5" width="4" height="2.5" rx="0.3" strokeWidth="0.8" />
    
    {/* Sleeper */}
    <rect x="9" y="6" width="3" height="6" strokeWidth="1.3" />
    
    {/* Exhaust stacks */}
    <line x1="8" y1="6" x2="8" y2="3" strokeWidth="1.5" />
    <line x1="10" y1="6" x2="10" y2="3" strokeWidth="1.5" />
    
    {/* Grille lines */}
    <line x1="2" y1="8" x2="2" y2="11" strokeWidth="0.8" />
    <line x1="3.5" y1="7.5" x2="3.5" y2="11" strokeWidth="0.8" />
    <line x1="5" y1="7.5" x2="5" y2="11" strokeWidth="0.8" />
    
    {/* Bumper */}
    <path d="M0.5 12H9" strokeWidth="1.8" />
    
    {/* Fuel tank */}
    <rect x="9.5" y="9" width="1.5" height="3" rx="0.3" strokeWidth="0.6" />
    
    {/* Fifth wheel connection */}
    <path d="M12 10h2" strokeWidth="1.5" />
    
    {/* Trailer */}
    <rect x="14" y="4" width="17" height="8" rx="0.5" strokeWidth="1.3" />
    
    {/* Trailer detail lines */}
    <line x1="20" y1="4" x2="20" y2="12" strokeWidth="0.5" />
    <line x1="26" y1="4" x2="26" y2="12" strokeWidth="0.5" />
    
    {/* Front wheel */}
    <circle cx="5" cy="14.5" r="2.5" strokeWidth="1.5" />
    <circle cx="5" cy="14.5" r="1" strokeWidth="0.6" />
    
    {/* Drive wheels (dual) */}
    <circle cx="11" cy="14.5" r="2.5" strokeWidth="1.5" />
    <circle cx="11" cy="14.5" r="1" strokeWidth="0.6" />
    
    {/* Trailer wheels */}
    <circle cx="22" cy="14.5" r="2.5" strokeWidth="1.5" />
    <circle cx="22" cy="14.5" r="1" strokeWidth="0.6" />
    
    <circle cx="28" cy="14.5" r="2.5" strokeWidth="1.5" />
    <circle cx="28" cy="14.5" r="1" strokeWidth="0.6" />
    
    {/* Headlight */}
    <circle cx="1.5" cy="10" r="0.6" fill="currentColor" />
  </svg>
);

export default SemiTrailer;
